import { keepPreviousData, useQuery } from '@tanstack/react-query';

import { gqlClient } from '@/api/graphql-client';
import customerKeys from '@/api/queries/customers/keyFactory';
import { graphql } from '@/gql';
import { GetAddressesForCustomerInput, PaginationInput } from '@/gql/graphql';
import { PAGINATION_ARG_DEFAULTS } from '@payaca/shared-isomorphic/constants/graphql-pagination';

const GetCustomerAddressesQuery = graphql(`
  query CustomerAddresses(
    $customerId: ID!
    $pagination: PaginationInput!
    $input: GetAddressesForCustomerInput
  ) {
    customer(id: $customerId) {
      id
      paginatedAddresses(pagination: $pagination, input: $input) {
        items {
          id
          publicId
          line1
          line2
          city
          administrativeArea
          postalCode
          country
          fullLocalAddress
          coordinatesSource
          coordinates {
            latitude
            longitude
          }
          contacts {
            id
            publicId
            name
            description
            email
            phone
          }
        }
        limit
        offset
        totalCount
      }
    }
  }
`);

const useGetCustomerAddresses = (
  customerId?: string,
  input?: GetAddressesForCustomerInput,
  pagination?: PaginationInput
) => {
  const { data, ...rest } = useQuery({
    enabled: !!customerId,
    queryKey: customerKeys.customerAddresses(customerId!, input, pagination),
    queryFn: () => {
      return gqlClient.request(GetCustomerAddressesQuery, {
        customerId: customerId!,
        input,
        pagination: pagination || PAGINATION_ARG_DEFAULTS,
      });
    },
    placeholderData: keepPreviousData,
  });

  return {
    addresses: data?.customer?.paginatedAddresses,
    data,
    ...rest,
  };
};

export default useGetCustomerAddresses;
